<template>
  <div ref="targetEl" :class="classes.wrapper">
    <OfferButton
      :class="[classes.offerButton, 'test-option']"
      :buttonId="buttonId"
      :text="buttonText"
      @click="event => handleClick(event)"
    />
  </div>
</template>

<script lang="ts">
import { createUseStyles } from "@fresh8/vue-jss/src";
import OfferButton from "../../styled/OfferButton.vue";
import { defineComponent, computed } from "vue";
import { composePopoverForm } from "@fresh8/ad-data-composition/src/popoverForm";
import { injectBrand } from "@fresh8/ad-data-composition/src/brand";
import { injectCardNumber, useAnalytics } from "../../../hooks/useAnalytics";
import { injectOffer } from "@fresh8/ad-data-composition/src/offer";
import { injectPreview } from "@fresh8/ad-data-composition/src/preview";

const useStyles = createUseStyles({
  wrapper: {
    height: "100%",
    width: "100%"
  },
  offerButton: {
    display: "flex",
    flex: 1,
    height: "100%",
    width: "100%",
    fontSize: "14px",
    alignItems: "center",
    textAlign: "center"
  }
});

export default defineComponent({
  components: { OfferButton },
  setup(props) {
    const brandContext = injectBrand();
    const classes = useStyles();
    const cardNumber = injectCardNumber();
    const offerContext = injectOffer();
    const previewContext = injectPreview();

    const { handleClick } = useAnalytics(
      { cardNumber: cardNumber },
      "Offer Button"
    );

    const { targetEl } = composePopoverForm("Offer Button", [
      {
        type: "button",
        get: () => brandContext?.brand.value?.adTemplate.offer?.button ?? "",
        set: (value: string) => {
          if (brandContext?.brand.value) {
            if (!brandContext.brand.value.adTemplate.offer) {
              brandContext.brand.value.adTemplate.offer = {
                header: "",
                body: "",
                button: "",
                terms: ""
              };
            }
            brandContext.brand.value.adTemplate.offer.button = value;
          }
        }
      }
    ]);

    return {
      classes,
      handleClick: event => {
        // if it's the preview we need the event to propagate so it opens the popover form
        if (!previewContext?.preview.value.isPreview) {
          // The offer button is wrapped in a link so we need
          // to stopPropagation so it doesn't fire two events.
          event.stopPropagation();
        }

        handleClick();
      },
      targetEl,
      buttonId: computed(
        () =>
          brandContext?.adTemplate.value?.offer?.button ||
          (brandContext?.buttons.value &&
            Object.keys(brandContext?.buttons.value)[0]) ||
          ""
      ),
      buttonText: computed(
        () =>
          (offerContext?.offer.value && offerContext?.offer.value.buttonText) ||
          ""
      )
    };
  }
});
</script>
